// The N1 offer is staged PUBLIC with zero stock before Bluetooth SIG
// qualification and the first sale. During that window an unavailable product
// must read "Coming soon", not "Sold out" — sold-out implies units were sold.
// Flip to false when the first batch opens so real sell-outs read correctly.
export const DONGL_PRELAUNCH = true;
